import { toast } from "sonner";
import { marked } from "marked";
import { useCreateDocument } from "./useCreateDocument";
import { useConvertHtmlToSfdt } from "./useConvertHtmlToSfdt";
import { getTileContentAsText } from "../utils/tile.utils";
import { ReviewTileItem } from "../types/tile.types";

export const useCreateDocumentFromTiles = () => {
  const { mutateAsync: createDoc, isPending: isCreatingDocument } = useCreateDocument();
  const { mutateAsync: convertToSfdt, isPending: isConverting } = useConvertHtmlToSfdt();

  const createDocumentFromTiles = async (
    tiles: ReviewTileItem[],
    title: string = "Untitled Document"
  ) => {
    try {
      const texts = tiles.map((tile) =>
        getTileContentAsText(tile)
          .replace(/(^|\n)([^:\n]+):/g, "$1**$2:**")
          .replace(/\n/g, "\n\n")
      );
      const combinedText = texts.join("\n\n<br><br>\n\n");
      const htmlContent = await marked(combinedText);
      const sfdtContent = await convertToSfdt(htmlContent);

      const editorId =
        Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

      const result = await createDoc({
        editor_id: editorId,
        title: title,
        content: sfdtContent,
        collaborators: [],
        folderId: null,
      });

      toast.success("Success!", {
        description: `Document created successfully. Document ID: ${result.document_id}`,
      });

      if (result.document_id) {
        window.open(`${process.env.APP_FRONTEND_URL}/d/${result.document_id}`, "_blank");
      }

      return result;
    } catch (error) {
      console.error("Failed to create document from tiles:", error);
      toast.error("Creation Failed", {
        description: "Failed to create document. Please try again.",
      });
      throw error;
    }
  };

  return { createDocumentFromTiles, isCreatingDocument: isCreatingDocument || isConverting };
};
